import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const OrdersListLazy = loadable(() => import(/* webpackChunkName: "OrdersList" */ './OrdersListSuspense'));

export const OrdersListAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <OrdersListLazy />
    </DelayedSuspense>
);
